import { FormattedMessage } from "react-intl";

import { daysFrom } from "@citrine/utils/datetime";

import { ActivityTypeCard } from "../activity-type-card";

export function DatasetActivityCard({
  teamId,
  datasetId,
  datasetName,
  updatedTime,
  count,
  "data-testid": testId = "dataset-activity-card",
}: {
  teamId: string;
  datasetId: string;
  datasetName: string;
  updatedTime: number;
  count: number;
  ["data-testid"]?: string;
}) {
  return (
    <ActivityTypeCard
      data-testid={testId}
      to={`/data-manager/teams/${teamId}/data/materials?dataset=${datasetId}`}
      variant="data"
    >
      <FormattedMessage
        id="resources.dataset.activity-card-text"
        values={{
          bold: (content) => <strong>{content}</strong>,
          dataset: datasetName,
          days: daysFrom(new Date(), updatedTime),
          materials: count.toLocaleString(),
        }}
      />
    </ActivityTypeCard>
  );
}
